"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export default function MobileNavigationHighlighter() {
  const pathname = usePathname()

  useEffect(() => {
    // Function to update mobile nav highlighting
    const updateMobileHighlighting = () => {
      // Find mobile navigation
      const mobileNav = document.querySelector("div[class*='bg-interest-blue'] nav")
      if (!mobileNav) return

      // Remove all existing active classes from mobile nav
      const mobileLinks = mobileNav.querySelectorAll("a, button")
      mobileLinks.forEach((element) => {
        element.classList.remove("font-bold", "opacity-100")
        // Set default opacity for inactive items
        if (element.tagName === "A" || element.tagName === "BUTTON") {
          element.classList.add("opacity-75")
        }
      })

      // Add active classes to current links
      mobileLinks.forEach((element) => {
        const href = element.getAttribute("href")
        if (!href) return

        const isActive = (href === "/" && pathname === "/") || (href !== "/" && pathname.startsWith(href))

        if (isActive) {
          element.classList.remove("opacity-75")
          element.classList.add("opacity-100", "font-bold")
        }
      })

      // Check for parent buttons that should be highlighted based on pathname
      const parentButtons = mobileNav.querySelectorAll("button[data-has-children='true']")
      parentButtons.forEach((button) => {
        const menuPath = button.getAttribute("data-menu-path")

        // If the button has a path and current pathname starts with it, highlight it
        if (menuPath && pathname.startsWith(menuPath)) {
          button.classList.remove("opacity-75")
          button.classList.add("opacity-100", "font-bold")
          return
        }

        // Otherwise, check if any child links under this button match the current path
        const parentDiv = button.closest("div")
        if (!parentDiv) return

        // Look for child links in the next sibling element (the submenu)
        const submenuLinks = parentDiv.querySelectorAll("a")
        let hasActiveChild = false

        submenuLinks.forEach((link) => {
          const href = link.getAttribute("href")
          if (href && pathname.startsWith(href)) {
            hasActiveChild = true
          }
        })

        if (hasActiveChild) {
          button.classList.remove("opacity-75")
          button.classList.add("opacity-100", "font-bold")
        }
      })
    }

    // Update highlighting immediately
    updateMobileHighlighting()

    // Also update when mobile menu might be opened
    // Use MutationObserver to detect when mobile menu is rendered
    const observer = new MutationObserver(() => {
      updateMobileHighlighting()
    })

    // Observe the body for changes (mobile menu being added/removed)
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
    }
  }, [pathname])

  return null
}
